export const ContactHelper = {
  getContactValidator () {
    return {
      name: '',
      isValid: true,
      check (model) {
        const trimmedName = (model.name || '').trim()
        const hasAnyValue = Object.values(model).some(value => !!(value && String(value).trim()))

        if (!hasAnyValue) {
          this.name = ''
          this.isValid = true
          return
        }

        this.name = trimmedName ? '' : 'Please enter contact name.'
        this.isValid = !this.name
      }
    }
  }
}
